import { DS_getData } from '../DS/DS.Data'
import { salts } from '../../../shared/cfg/salts.no-deps'

const pad = (value: string, width: number) => {
    return value.length >= width ? value : new Array(width - value.length + 1).join('0') + value
}

export const Noti_getTopicName = async () => {
    const { user, customer } = DS_getData()
    const encoder = new TextEncoder()
    const data = encoder.encode(`${user.email}-${customer.id}-${salts.topic}`)
    const buffer = await crypto.subtle.digest('SHA-256', data)

    const byteArray = new Uint8Array(buffer)

    return byteArray.reduce((output, value) => {
        const hexCode = value.toString(16)
        const paddedHexCode = pad(hexCode, 2)
        return output + paddedHexCode
    }, '')
}
